import { createStyled, shouldForwardProp } from "@mui/system";
import { theme } from "../theme/index.js";
import { THEME_ID } from "../constants/index.js";
const rootShouldForwardProp = (prop) => shouldForwardProp(prop) && prop !== "classes";
const slotShouldForwardProp = shouldForwardProp;
const styled = createStyled({
  defaultTheme: theme,
  themeId: THEME_ID,
  rootShouldForwardProp,
  slotShouldForwardProp
});
export {
  rootShouldForwardProp,
  slotShouldForwardProp,
  styled
};
